window.addEventListener('DOMContentLoaded', () => {
    const clickHandler = (e) => {
        const targetId = e.target.hash.replace('#', '');
        if (!targetId) {
            return;
        }
        const target = document.getElementById(targetId);
        if (!target) {
            return;
        }
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
    };

    const triggers = document.querySelectorAll('[data-smooth-scroll]');
    [...triggers].map((trigger) => {
        trigger.addEventListener('click', clickHandler);
    });
});